module.exports = __webpack_public_path__ + "img/nrlogo_tr.d3a701d1.png";